import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/browser";

import "./index.css";
import AppRouter from "./Router";
import configureStore from "./configureStore";
import IframeAdapter from "./utils/IframeAdapter";

const store = configureStore();

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    release: process.env.REACT_APP_VERSION,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    ignoreErrors: [
      "top.GLOBALS",
      "getReadModeExtract",
      "getReadModeConfig",
      "getReadModeRender"
    ],
    allowUrls: [/https:\/\/((static|form|api)\.)?in\.lyra\.com/],
    beforeSend(event, hint) {
      // Ignore Chrome Mobile WebView certain versions crawlers
      if (hint.originalException.name === "SyntaxError")
        if (
          window.navigator.userAgent.indexOf("Chrome/70.0.3538") ||
          window.navigator.userAgent.indexOf("Chrome/44.0.2403") !== -1
        )
          return null;
      return event;
    }
  });
  Sentry.setTag("app_name", "frontend");
}

ReactDOM.render(
  <Provider store={store}>
    <AppRouter />
    <IframeAdapter />
  </Provider>,
  document.getElementById("root")
);
